<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M6.36143 9.00034L16.9998 9.00035L16.9998 11.0003L6.36579 11.0003L7.72918 12.3631L6.54739 13.5459L3.00203 9.9995L4.77361 8.22608L6.54739 6.45418L7.72896 7.63596L6.36143 9.00034Z"
    fill="currentColor"
  />
</svg>
